var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 336.84,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 175.16
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "388.495,198.496 388.495,174.406 364.405,174.406 364.405,114.18 376.45,114.18    376.45,90.09 304.179,90.09 304.179,114.18 316.224,114.18 316.224,174.406 280.089,174.406 280.089,90.09 292.134,90.09    292.134,66 219.864,66 219.864,90.09 231.909,90.09 231.909,174.406 195.773,174.406 195.773,114.18 207.818,114.18 207.818,90.09    135.548,90.09 135.548,114.18 147.593,114.18 147.593,174.406 123.503,174.406 123.503,198.496 135.548,198.496 135.548,294.857    123.503,294.857 123.503,318.947 388.495,318.947 388.495,294.857 376.45,294.857 376.45,198.496  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M280.089,306.902h-48.18v-56.271c0-8.837,7.163-16,16-16h16.18c8.837,0,16,7.163,16,16V306.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M255.999,138.271c-6.652,0-12.045,5.393-12.045,12.045v36.135h24.09v-36.135   C268.044,143.663,262.651,138.271,255.999,138.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M340.315,150.316c-6.652,0-12.045,5.393-12.045,12.045v24.09h24.09v-24.09   C352.36,155.708,346.967,150.316,340.315,150.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M171.683,150.316c-6.652,0-12.045,5.393-12.045,12.045v24.09h24.09v-24.09   C183.728,155.708,178.335,150.316,171.683,150.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M352.36,306.902h-48.18v-44.226c0-8.837,7.163-16,16-16h16.18c8.837,0,16,7.163,16,16V306.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M207.818,306.902h-48.18v-44.226c0-8.837,7.163-16,16-16h16.18c8.837,0,16,7.163,16,16V306.902z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M293.052,357.053c0-2.25-1.125-4.355-3-5.605l-27.316-18.211v-5.704l23.224-11.612  c3.329-1.664,4.678-5.711,3.013-9.039c-1.671-3.336-5.704-4.678-9.039-3.013L256,315.836l-23.934-11.967  c-3.316-1.664-7.375-0.322-9.039,3.013c-1.664,3.329-0.316,7.375,3.013,9.039l23.224,11.612v5.704l-27.316,18.211  c-1.875,1.25-3,3.355-3,5.605s1.125,4.355,3,5.605l27.316,18.211v57.026h-26.947v10.316c0,3.724,3.013,6.737,6.737,6.737  c2.579,0,4.822-1.447,5.954-3.579h14.257v13.474H234.89c-1.164-2.013-3.342-3.368-5.836-3.368c-3.724,0-6.737,3.013-6.737,6.737  v10.105h26.947v6.737c0,3.724,3.013,6.737,6.737,6.737s6.737-3.013,6.737-6.737v-6.737v-40.421V380.87l27.316-18.211  C291.927,361.408,293.052,359.303,293.052,357.053z M255.999,369.164l-18.171-12.112l18.171-12.112l18.171,12.112L255.999,369.164z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/gi.0062c82de9adec1adf72ad9f2af7f5f3.svg";
export { ForwardRef as ReactComponent };